export default __webpack_public_path__ + "static/media/fourohfour.579a93ef.png";